import useAnalytics from '@hooks/use-analytics'
import type { TypeProvider } from '@lib/types'
import { Typography, Modal, ExpandableContent, Collapsible } from '@shc/ui'
import { Fragment, type Dispatch, type SetStateAction } from 'react'

type ProviderInsuranceModalProps = {
  provider: TypeProvider
  isModalOpen: boolean
  setIsModalOpen: Dispatch<SetStateAction<boolean>>
}

const ProviderInsuranceModal = ({
  provider,
  isModalOpen,
  setIsModalOpen,
}: ProviderInsuranceModalProps) => {
  

  const groupedPlans = {};
  for(const insurance of provider.insurances_facet){
    const [ provider, plan ] = insurance.split(' > ');
    if( provider in groupedPlans ){
      if( plan ){
        groupedPlans[provider].push(plan);
      }
    } else {
      groupedPlans[provider] = plan ? [plan] : [];
    }
  }
  const { track: trackSnowplow } = useAnalytics()

  const handleOpenChange = (state: boolean, insurer_name: string) => {
    trackSnowplow({
      event: { name: state ? 'component_expand' : 'component_collapse', data: {} },
      contexts: [
        {
          name: 'component',
          data: {
            component_text: insurer_name,
          },
        },
      ],
    })
  }

  return (
    <Modal
      width="md"
      open={isModalOpen}
      onClose={() => {
        setIsModalOpen(false)
        trackSnowplow({
          event: { name: 'modal_close', data: {} },
          contexts: [{ name: 'modal', data: { modal_name: 'InsuranceModal' } }],
        })
      }}>
      <div className="flex flex-col" data-testid="insurance-modal">
        <Typography variant="h2" align="center" className="px-7 pb-8">
          Insurance plans accepted
        </Typography>
        <Typography className="pb-8">
          Sharp accepts most health insurance. Not all plans are listed. Please contact your
          insurance company to verify your insurance type and plan.
        </Typography>
        <Typography variant="body-semibold" className="pb-4">
          In-network insurance plans
        </Typography>
        <ExpandableContent>
          { Object.keys(groupedPlans).map((k: string) => (
            <Collapsible
              key={k}
              heading={k}
              description={
                <div>
                  {groupedPlans[k].map((plan: string) => (
                    <Fragment key={plan}>
                      <Typography>{plan}</Typography>
                    </Fragment>
                  ))}
                </div>
              }
              onOpenChange={(open: boolean) => handleOpenChange(open, k)}
            />
          ))}
        </ExpandableContent>
      </div>
    </Modal>
  )
}

export default ProviderInsuranceModal
